/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as RedirectingRouteImport } from './routes/redirecting'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as AuthLayoutRouteImport } from './routes/_auth-layout'
import { Route as AuthLayoutIndexRouteImport } from './routes/_auth-layout.index'
import { Route as LayoutprivateProfileRouteImport } from './routes/_layout.(private)/profile'
import { Route as LayoutprivateDashboardRouteImport } from './routes/_layout.(private)/dashboard'
import { Route as AuthLayoutauthForgotPasswordRouteImport } from './routes/_auth-layout.(auth)/forgot-password'
import { Route as LayoutprivateTasksIndexRouteImport } from './routes/_layout.(private)/tasks/index'
import { Route as LayoutprivateServiceRequestsIndexRouteImport } from './routes/_layout.(private)/service-requests/index'
import { Route as LayoutprivateProvidersIndexRouteImport } from './routes/_layout.(private)/providers/index'
import { Route as LayoutprivateInterventionsIndexRouteImport } from './routes/_layout.(private)/interventions/index'
import { Route as LayoutprivateBusinessLinesIndexRouteImport } from './routes/_layout.(private)/business-lines/index'
import { Route as LayoutprivateAdminsIndexRouteImport } from './routes/_layout.(private)/admins/index'
import { Route as LayoutprivateServiceRequestsCreateRouteImport } from './routes/_layout.(private)/service-requests/create'
import { Route as LayoutprivateBusinessLinesCreateRouteImport } from './routes/_layout.(private)/business-lines/create'
import { Route as LayoutprivateAdminsCreateRouteImport } from './routes/_layout.(private)/admins/create'
import { Route as LayoutprivateServiceRequestsIdIndexRouteImport } from './routes/_layout.(private)/service-requests/$id/index'
import { Route as LayoutprivateRequestersIdIndexRouteImport } from './routes/_layout.(private)/requesters/$id/index'
import { Route as LayoutprivateProvidersIdIndexRouteImport } from './routes/_layout.(private)/providers/$id/index'
import { Route as LayoutprivateBusinessLinesIdIndexRouteImport } from './routes/_layout.(private)/business-lines/$id/index'
import { Route as LayoutprivateServiceRequestsIdUpdateRouteImport } from './routes/_layout.(private)/service-requests/$id/update'
import { Route as LayoutprivateServiceRequestsIdSmartMatchRouteImport } from './routes/_layout.(private)/service-requests/$id/smart-match'
import { Route as LayoutprivateRequestersIdUpdateRouteImport } from './routes/_layout.(private)/requesters/$id/update'
import { Route as LayoutprivateProvidersIdUpdateRouteImport } from './routes/_layout.(private)/providers/$id/update'
import { Route as LayoutprivateBusinessLinesIdUpdateRouteImport } from './routes/_layout.(private)/business-lines/$id/update'
import { Route as LayoutprivateAdminsIdUpdateRouteImport } from './routes/_layout.(private)/admins/$id/update'
import { Route as LayoutprivateServiceRequestsIdTasksCreateRouteImport } from './routes/_layout.(private)/service-requests/$id/tasks/create'
import { Route as LayoutprivateServiceRequestsIdNotesCreateRouteImport } from './routes/_layout.(private)/service-requests/$id/notes/create'
import { Route as LayoutprivateServiceRequestsIdInterventionsCreateRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/create'
import { Route as LayoutprivateServiceRequestsIdEmailsSendRouteImport } from './routes/_layout.(private)/service-requests/$id/emails/send'
import { Route as LayoutprivateServiceRequestsIdDocumentsAddRouteImport } from './routes/_layout.(private)/service-requests/$id/documents/add'
import { Route as LayoutprivateProvidersIdWorkersCreateRouteImport } from './routes/_layout.(private)/providers/$id/workers/create'
import { Route as LayoutprivateProvidersIdPartnershipsCreateRouteImport } from './routes/_layout.(private)/providers/$id/partnerships/create'
import { Route as LayoutprivateProvidersIdNotesCreateRouteImport } from './routes/_layout.(private)/providers/$id/notes/create'
import { Route as LayoutprivateBusinessLinesIdServicesCreateRouteImport } from './routes/_layout.(private)/business-lines/$id/services/create'
import { Route as LayoutprivateServiceRequestsIdTasksTaskIdUpdateRouteImport } from './routes/_layout.(private)/service-requests/$id/tasks/$taskId.update'
import { Route as LayoutprivateServiceRequestsIdNotesNoteIdUpdateRouteImport } from './routes/_layout.(private)/service-requests/$id/notes/$noteId.update'
import { Route as LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/$interventionId/update'
import { Route as LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRouteImport } from './routes/_layout.(private)/providers/$id/partnerships/$partnershipId.update'
import { Route as LayoutprivateProvidersIdNotesNoteIdUpdateRouteImport } from './routes/_layout.(private)/providers/$id/notes/$noteId.update'
import { Route as LayoutprivateProvidersIdCompaniesCompanyIdUpdateRouteImport } from './routes/_layout.(private)/providers/$id/companies/$companyId.update'
import { Route as LayoutprivateBusinessLinesIdServicesServiceIdUpdateRouteImport } from './routes/_layout.(private)/business-lines/$id/services/$serviceId/update'
import { Route as LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/$interventionId/tasks/create'
import { Route as LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/$interventionId/notes/create'
import { Route as LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/$interventionId/emails/send'
import { Route as LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/$interventionId/documents/add'
import { Route as LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/$interventionId/tasks/$taskId.update'
import { Route as LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRouteImport } from './routes/_layout.(private)/service-requests/$id/interventions/$interventionId/notes/$noteId.update'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const RedirectingRoute = RedirectingRouteImport.update({
  id: '/redirecting',
  path: '/redirecting',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutIndexRoute = AuthLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const LayoutprivateProfileRoute = LayoutprivateProfileRouteImport.update({
  id: '/(private)/profile',
  path: '/profile',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutprivateDashboardRoute = LayoutprivateDashboardRouteImport.update({
  id: '/(private)/dashboard',
  path: '/dashboard',
  getParentRoute: () => LayoutRoute,
} as any)
const AuthLayoutauthForgotPasswordRoute =
  AuthLayoutauthForgotPasswordRouteImport.update({
    id: '/(auth)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const LayoutprivateTasksIndexRoute = LayoutprivateTasksIndexRouteImport.update({
  id: '/(private)/tasks/',
  path: '/tasks/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutprivateServiceRequestsIndexRoute =
  LayoutprivateServiceRequestsIndexRouteImport.update({
    id: '/(private)/service-requests/',
    path: '/service-requests/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIndexRoute =
  LayoutprivateProvidersIndexRouteImport.update({
    id: '/(private)/providers/',
    path: '/providers/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateInterventionsIndexRoute =
  LayoutprivateInterventionsIndexRouteImport.update({
    id: '/(private)/interventions/',
    path: '/interventions/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateBusinessLinesIndexRoute =
  LayoutprivateBusinessLinesIndexRouteImport.update({
    id: '/(private)/business-lines/',
    path: '/business-lines/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateAdminsIndexRoute =
  LayoutprivateAdminsIndexRouteImport.update({
    id: '/(private)/admins/',
    path: '/admins/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsCreateRoute =
  LayoutprivateServiceRequestsCreateRouteImport.update({
    id: '/(private)/service-requests/create',
    path: '/service-requests/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateBusinessLinesCreateRoute =
  LayoutprivateBusinessLinesCreateRouteImport.update({
    id: '/(private)/business-lines/create',
    path: '/business-lines/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateAdminsCreateRoute =
  LayoutprivateAdminsCreateRouteImport.update({
    id: '/(private)/admins/create',
    path: '/admins/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdIndexRoute =
  LayoutprivateServiceRequestsIdIndexRouteImport.update({
    id: '/(private)/service-requests/$id/',
    path: '/service-requests/$id/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateRequestersIdIndexRoute =
  LayoutprivateRequestersIdIndexRouteImport.update({
    id: '/(private)/requesters/$id/',
    path: '/requesters/$id/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIdIndexRoute =
  LayoutprivateProvidersIdIndexRouteImport.update({
    id: '/(private)/providers/$id/',
    path: '/providers/$id/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateBusinessLinesIdIndexRoute =
  LayoutprivateBusinessLinesIdIndexRouteImport.update({
    id: '/(private)/business-lines/$id/',
    path: '/business-lines/$id/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdUpdateRoute =
  LayoutprivateServiceRequestsIdUpdateRouteImport.update({
    id: '/(private)/service-requests/$id/update',
    path: '/service-requests/$id/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdSmartMatchRoute =
  LayoutprivateServiceRequestsIdSmartMatchRouteImport.update({
    id: '/(private)/service-requests/$id/smart-match',
    path: '/service-requests/$id/smart-match',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateRequestersIdUpdateRoute =
  LayoutprivateRequestersIdUpdateRouteImport.update({
    id: '/(private)/requesters/$id/update',
    path: '/requesters/$id/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIdUpdateRoute =
  LayoutprivateProvidersIdUpdateRouteImport.update({
    id: '/(private)/providers/$id/update',
    path: '/providers/$id/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateBusinessLinesIdUpdateRoute =
  LayoutprivateBusinessLinesIdUpdateRouteImport.update({
    id: '/(private)/business-lines/$id/update',
    path: '/business-lines/$id/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateAdminsIdUpdateRoute =
  LayoutprivateAdminsIdUpdateRouteImport.update({
    id: '/(private)/admins/$id/update',
    path: '/admins/$id/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdTasksCreateRoute =
  LayoutprivateServiceRequestsIdTasksCreateRouteImport.update({
    id: '/(private)/service-requests/$id/tasks/create',
    path: '/service-requests/$id/tasks/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdNotesCreateRoute =
  LayoutprivateServiceRequestsIdNotesCreateRouteImport.update({
    id: '/(private)/service-requests/$id/notes/create',
    path: '/service-requests/$id/notes/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdInterventionsCreateRoute =
  LayoutprivateServiceRequestsIdInterventionsCreateRouteImport.update({
    id: '/(private)/service-requests/$id/interventions/create',
    path: '/service-requests/$id/interventions/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdEmailsSendRoute =
  LayoutprivateServiceRequestsIdEmailsSendRouteImport.update({
    id: '/(private)/service-requests/$id/emails/send',
    path: '/service-requests/$id/emails/send',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdDocumentsAddRoute =
  LayoutprivateServiceRequestsIdDocumentsAddRouteImport.update({
    id: '/(private)/service-requests/$id/documents/add',
    path: '/service-requests/$id/documents/add',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIdWorkersCreateRoute =
  LayoutprivateProvidersIdWorkersCreateRouteImport.update({
    id: '/(private)/providers/$id/workers/create',
    path: '/providers/$id/workers/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIdPartnershipsCreateRoute =
  LayoutprivateProvidersIdPartnershipsCreateRouteImport.update({
    id: '/(private)/providers/$id/partnerships/create',
    path: '/providers/$id/partnerships/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIdNotesCreateRoute =
  LayoutprivateProvidersIdNotesCreateRouteImport.update({
    id: '/(private)/providers/$id/notes/create',
    path: '/providers/$id/notes/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateBusinessLinesIdServicesCreateRoute =
  LayoutprivateBusinessLinesIdServicesCreateRouteImport.update({
    id: '/(private)/business-lines/$id/services/create',
    path: '/business-lines/$id/services/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute =
  LayoutprivateServiceRequestsIdTasksTaskIdUpdateRouteImport.update({
    id: '/(private)/service-requests/$id/tasks/$taskId/update',
    path: '/service-requests/$id/tasks/$taskId/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute =
  LayoutprivateServiceRequestsIdNotesNoteIdUpdateRouteImport.update({
    id: '/(private)/service-requests/$id/notes/$noteId/update',
    path: '/service-requests/$id/notes/$noteId/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute =
  LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRouteImport.update(
    {
      id: '/(private)/service-requests/$id/interventions/$interventionId/update',
      path: '/service-requests/$id/interventions/$interventionId/update',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute =
  LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRouteImport.update({
    id: '/(private)/providers/$id/partnerships/$partnershipId/update',
    path: '/providers/$id/partnerships/$partnershipId/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIdNotesNoteIdUpdateRoute =
  LayoutprivateProvidersIdNotesNoteIdUpdateRouteImport.update({
    id: '/(private)/providers/$id/notes/$noteId/update',
    path: '/providers/$id/notes/$noteId/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute =
  LayoutprivateProvidersIdCompaniesCompanyIdUpdateRouteImport.update({
    id: '/(private)/providers/$id/companies/$companyId/update',
    path: '/providers/$id/companies/$companyId/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute =
  LayoutprivateBusinessLinesIdServicesServiceIdUpdateRouteImport.update({
    id: '/(private)/business-lines/$id/services/$serviceId/update',
    path: '/business-lines/$id/services/$serviceId/update',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute =
  LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRouteImport.update(
    {
      id: '/(private)/service-requests/$id/interventions/$interventionId/tasks/create',
      path: '/service-requests/$id/interventions/$interventionId/tasks/create',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute =
  LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRouteImport.update(
    {
      id: '/(private)/service-requests/$id/interventions/$interventionId/notes/create',
      path: '/service-requests/$id/interventions/$interventionId/notes/create',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute =
  LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRouteImport.update(
    {
      id: '/(private)/service-requests/$id/interventions/$interventionId/emails/send',
      path: '/service-requests/$id/interventions/$interventionId/emails/send',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute =
  LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRouteImport.update(
    {
      id: '/(private)/service-requests/$id/interventions/$interventionId/documents/add',
      path: '/service-requests/$id/interventions/$interventionId/documents/add',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute =
  LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRouteImport.update(
    {
      id: '/(private)/service-requests/$id/interventions/$interventionId/tasks/$taskId/update',
      path: '/service-requests/$id/interventions/$interventionId/tasks/$taskId/update',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute =
  LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRouteImport.update(
    {
      id: '/(private)/service-requests/$id/interventions/$interventionId/notes/$noteId/update',
      path: '/service-requests/$id/interventions/$interventionId/notes/$noteId/update',
      getParentRoute: () => LayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/redirecting': typeof RedirectingRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/': typeof AuthLayoutIndexRoute
  '/forgot-password': typeof AuthLayoutauthForgotPasswordRoute
  '/dashboard': typeof LayoutprivateDashboardRoute
  '/profile': typeof LayoutprivateProfileRoute
  '/admins/create': typeof LayoutprivateAdminsCreateRoute
  '/business-lines/create': typeof LayoutprivateBusinessLinesCreateRoute
  '/service-requests/create': typeof LayoutprivateServiceRequestsCreateRoute
  '/admins': typeof LayoutprivateAdminsIndexRoute
  '/business-lines': typeof LayoutprivateBusinessLinesIndexRoute
  '/interventions': typeof LayoutprivateInterventionsIndexRoute
  '/providers': typeof LayoutprivateProvidersIndexRoute
  '/service-requests': typeof LayoutprivateServiceRequestsIndexRoute
  '/tasks': typeof LayoutprivateTasksIndexRoute
  '/admins/$id/update': typeof LayoutprivateAdminsIdUpdateRoute
  '/business-lines/$id/update': typeof LayoutprivateBusinessLinesIdUpdateRoute
  '/providers/$id/update': typeof LayoutprivateProvidersIdUpdateRoute
  '/requesters/$id/update': typeof LayoutprivateRequestersIdUpdateRoute
  '/service-requests/$id/smart-match': typeof LayoutprivateServiceRequestsIdSmartMatchRoute
  '/service-requests/$id/update': typeof LayoutprivateServiceRequestsIdUpdateRoute
  '/business-lines/$id': typeof LayoutprivateBusinessLinesIdIndexRoute
  '/providers/$id': typeof LayoutprivateProvidersIdIndexRoute
  '/requesters/$id': typeof LayoutprivateRequestersIdIndexRoute
  '/service-requests/$id': typeof LayoutprivateServiceRequestsIdIndexRoute
  '/business-lines/$id/services/create': typeof LayoutprivateBusinessLinesIdServicesCreateRoute
  '/providers/$id/notes/create': typeof LayoutprivateProvidersIdNotesCreateRoute
  '/providers/$id/partnerships/create': typeof LayoutprivateProvidersIdPartnershipsCreateRoute
  '/providers/$id/workers/create': typeof LayoutprivateProvidersIdWorkersCreateRoute
  '/service-requests/$id/documents/add': typeof LayoutprivateServiceRequestsIdDocumentsAddRoute
  '/service-requests/$id/emails/send': typeof LayoutprivateServiceRequestsIdEmailsSendRoute
  '/service-requests/$id/interventions/create': typeof LayoutprivateServiceRequestsIdInterventionsCreateRoute
  '/service-requests/$id/notes/create': typeof LayoutprivateServiceRequestsIdNotesCreateRoute
  '/service-requests/$id/tasks/create': typeof LayoutprivateServiceRequestsIdTasksCreateRoute
  '/business-lines/$id/services/$serviceId/update': typeof LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute
  '/providers/$id/companies/$companyId/update': typeof LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute
  '/providers/$id/notes/$noteId/update': typeof LayoutprivateProvidersIdNotesNoteIdUpdateRoute
  '/providers/$id/partnerships/$partnershipId/update': typeof LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute
  '/service-requests/$id/interventions/$interventionId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute
  '/service-requests/$id/notes/$noteId/update': typeof LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute
  '/service-requests/$id/tasks/$taskId/update': typeof LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute
  '/service-requests/$id/interventions/$interventionId/documents/add': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute
  '/service-requests/$id/interventions/$interventionId/emails/send': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute
  '/service-requests/$id/interventions/$interventionId/notes/create': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute
  '/service-requests/$id/interventions/$interventionId/tasks/create': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute
  '/service-requests/$id/interventions/$interventionId/notes/$noteId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute
  '/service-requests/$id/interventions/$interventionId/tasks/$taskId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute
}
export interface FileRoutesByTo {
  '/redirecting': typeof RedirectingRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/': typeof AuthLayoutIndexRoute
  '/forgot-password': typeof AuthLayoutauthForgotPasswordRoute
  '/dashboard': typeof LayoutprivateDashboardRoute
  '/profile': typeof LayoutprivateProfileRoute
  '/admins/create': typeof LayoutprivateAdminsCreateRoute
  '/business-lines/create': typeof LayoutprivateBusinessLinesCreateRoute
  '/service-requests/create': typeof LayoutprivateServiceRequestsCreateRoute
  '/admins': typeof LayoutprivateAdminsIndexRoute
  '/business-lines': typeof LayoutprivateBusinessLinesIndexRoute
  '/interventions': typeof LayoutprivateInterventionsIndexRoute
  '/providers': typeof LayoutprivateProvidersIndexRoute
  '/service-requests': typeof LayoutprivateServiceRequestsIndexRoute
  '/tasks': typeof LayoutprivateTasksIndexRoute
  '/admins/$id/update': typeof LayoutprivateAdminsIdUpdateRoute
  '/business-lines/$id/update': typeof LayoutprivateBusinessLinesIdUpdateRoute
  '/providers/$id/update': typeof LayoutprivateProvidersIdUpdateRoute
  '/requesters/$id/update': typeof LayoutprivateRequestersIdUpdateRoute
  '/service-requests/$id/smart-match': typeof LayoutprivateServiceRequestsIdSmartMatchRoute
  '/service-requests/$id/update': typeof LayoutprivateServiceRequestsIdUpdateRoute
  '/business-lines/$id': typeof LayoutprivateBusinessLinesIdIndexRoute
  '/providers/$id': typeof LayoutprivateProvidersIdIndexRoute
  '/requesters/$id': typeof LayoutprivateRequestersIdIndexRoute
  '/service-requests/$id': typeof LayoutprivateServiceRequestsIdIndexRoute
  '/business-lines/$id/services/create': typeof LayoutprivateBusinessLinesIdServicesCreateRoute
  '/providers/$id/notes/create': typeof LayoutprivateProvidersIdNotesCreateRoute
  '/providers/$id/partnerships/create': typeof LayoutprivateProvidersIdPartnershipsCreateRoute
  '/providers/$id/workers/create': typeof LayoutprivateProvidersIdWorkersCreateRoute
  '/service-requests/$id/documents/add': typeof LayoutprivateServiceRequestsIdDocumentsAddRoute
  '/service-requests/$id/emails/send': typeof LayoutprivateServiceRequestsIdEmailsSendRoute
  '/service-requests/$id/interventions/create': typeof LayoutprivateServiceRequestsIdInterventionsCreateRoute
  '/service-requests/$id/notes/create': typeof LayoutprivateServiceRequestsIdNotesCreateRoute
  '/service-requests/$id/tasks/create': typeof LayoutprivateServiceRequestsIdTasksCreateRoute
  '/business-lines/$id/services/$serviceId/update': typeof LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute
  '/providers/$id/companies/$companyId/update': typeof LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute
  '/providers/$id/notes/$noteId/update': typeof LayoutprivateProvidersIdNotesNoteIdUpdateRoute
  '/providers/$id/partnerships/$partnershipId/update': typeof LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute
  '/service-requests/$id/interventions/$interventionId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute
  '/service-requests/$id/notes/$noteId/update': typeof LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute
  '/service-requests/$id/tasks/$taskId/update': typeof LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute
  '/service-requests/$id/interventions/$interventionId/documents/add': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute
  '/service-requests/$id/interventions/$interventionId/emails/send': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute
  '/service-requests/$id/interventions/$interventionId/notes/create': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute
  '/service-requests/$id/interventions/$interventionId/tasks/create': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute
  '/service-requests/$id/interventions/$interventionId/notes/$noteId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute
  '/service-requests/$id/interventions/$interventionId/tasks/$taskId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth-layout': typeof AuthLayoutRouteWithChildren
  '/_layout': typeof LayoutRouteWithChildren
  '/redirecting': typeof RedirectingRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_auth-layout/': typeof AuthLayoutIndexRoute
  '/_auth-layout/(auth)/forgot-password': typeof AuthLayoutauthForgotPasswordRoute
  '/_layout/(private)/dashboard': typeof LayoutprivateDashboardRoute
  '/_layout/(private)/profile': typeof LayoutprivateProfileRoute
  '/_layout/(private)/admins/create': typeof LayoutprivateAdminsCreateRoute
  '/_layout/(private)/business-lines/create': typeof LayoutprivateBusinessLinesCreateRoute
  '/_layout/(private)/service-requests/create': typeof LayoutprivateServiceRequestsCreateRoute
  '/_layout/(private)/admins/': typeof LayoutprivateAdminsIndexRoute
  '/_layout/(private)/business-lines/': typeof LayoutprivateBusinessLinesIndexRoute
  '/_layout/(private)/interventions/': typeof LayoutprivateInterventionsIndexRoute
  '/_layout/(private)/providers/': typeof LayoutprivateProvidersIndexRoute
  '/_layout/(private)/service-requests/': typeof LayoutprivateServiceRequestsIndexRoute
  '/_layout/(private)/tasks/': typeof LayoutprivateTasksIndexRoute
  '/_layout/(private)/admins/$id/update': typeof LayoutprivateAdminsIdUpdateRoute
  '/_layout/(private)/business-lines/$id/update': typeof LayoutprivateBusinessLinesIdUpdateRoute
  '/_layout/(private)/providers/$id/update': typeof LayoutprivateProvidersIdUpdateRoute
  '/_layout/(private)/requesters/$id/update': typeof LayoutprivateRequestersIdUpdateRoute
  '/_layout/(private)/service-requests/$id/smart-match': typeof LayoutprivateServiceRequestsIdSmartMatchRoute
  '/_layout/(private)/service-requests/$id/update': typeof LayoutprivateServiceRequestsIdUpdateRoute
  '/_layout/(private)/business-lines/$id/': typeof LayoutprivateBusinessLinesIdIndexRoute
  '/_layout/(private)/providers/$id/': typeof LayoutprivateProvidersIdIndexRoute
  '/_layout/(private)/requesters/$id/': typeof LayoutprivateRequestersIdIndexRoute
  '/_layout/(private)/service-requests/$id/': typeof LayoutprivateServiceRequestsIdIndexRoute
  '/_layout/(private)/business-lines/$id/services/create': typeof LayoutprivateBusinessLinesIdServicesCreateRoute
  '/_layout/(private)/providers/$id/notes/create': typeof LayoutprivateProvidersIdNotesCreateRoute
  '/_layout/(private)/providers/$id/partnerships/create': typeof LayoutprivateProvidersIdPartnershipsCreateRoute
  '/_layout/(private)/providers/$id/workers/create': typeof LayoutprivateProvidersIdWorkersCreateRoute
  '/_layout/(private)/service-requests/$id/documents/add': typeof LayoutprivateServiceRequestsIdDocumentsAddRoute
  '/_layout/(private)/service-requests/$id/emails/send': typeof LayoutprivateServiceRequestsIdEmailsSendRoute
  '/_layout/(private)/service-requests/$id/interventions/create': typeof LayoutprivateServiceRequestsIdInterventionsCreateRoute
  '/_layout/(private)/service-requests/$id/notes/create': typeof LayoutprivateServiceRequestsIdNotesCreateRoute
  '/_layout/(private)/service-requests/$id/tasks/create': typeof LayoutprivateServiceRequestsIdTasksCreateRoute
  '/_layout/(private)/business-lines/$id/services/$serviceId/update': typeof LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute
  '/_layout/(private)/providers/$id/companies/$companyId/update': typeof LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute
  '/_layout/(private)/providers/$id/notes/$noteId/update': typeof LayoutprivateProvidersIdNotesNoteIdUpdateRoute
  '/_layout/(private)/providers/$id/partnerships/$partnershipId/update': typeof LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute
  '/_layout/(private)/service-requests/$id/notes/$noteId/update': typeof LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute
  '/_layout/(private)/service-requests/$id/tasks/$taskId/update': typeof LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/documents/add': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/emails/send': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/create': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/create': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/$noteId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/$taskId/update': typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/redirecting'
    | '/unauthorized'
    | '/'
    | '/forgot-password'
    | '/dashboard'
    | '/profile'
    | '/admins/create'
    | '/business-lines/create'
    | '/service-requests/create'
    | '/admins'
    | '/business-lines'
    | '/interventions'
    | '/providers'
    | '/service-requests'
    | '/tasks'
    | '/admins/$id/update'
    | '/business-lines/$id/update'
    | '/providers/$id/update'
    | '/requesters/$id/update'
    | '/service-requests/$id/smart-match'
    | '/service-requests/$id/update'
    | '/business-lines/$id'
    | '/providers/$id'
    | '/requesters/$id'
    | '/service-requests/$id'
    | '/business-lines/$id/services/create'
    | '/providers/$id/notes/create'
    | '/providers/$id/partnerships/create'
    | '/providers/$id/workers/create'
    | '/service-requests/$id/documents/add'
    | '/service-requests/$id/emails/send'
    | '/service-requests/$id/interventions/create'
    | '/service-requests/$id/notes/create'
    | '/service-requests/$id/tasks/create'
    | '/business-lines/$id/services/$serviceId/update'
    | '/providers/$id/companies/$companyId/update'
    | '/providers/$id/notes/$noteId/update'
    | '/providers/$id/partnerships/$partnershipId/update'
    | '/service-requests/$id/interventions/$interventionId/update'
    | '/service-requests/$id/notes/$noteId/update'
    | '/service-requests/$id/tasks/$taskId/update'
    | '/service-requests/$id/interventions/$interventionId/documents/add'
    | '/service-requests/$id/interventions/$interventionId/emails/send'
    | '/service-requests/$id/interventions/$interventionId/notes/create'
    | '/service-requests/$id/interventions/$interventionId/tasks/create'
    | '/service-requests/$id/interventions/$interventionId/notes/$noteId/update'
    | '/service-requests/$id/interventions/$interventionId/tasks/$taskId/update'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/redirecting'
    | '/unauthorized'
    | '/'
    | '/forgot-password'
    | '/dashboard'
    | '/profile'
    | '/admins/create'
    | '/business-lines/create'
    | '/service-requests/create'
    | '/admins'
    | '/business-lines'
    | '/interventions'
    | '/providers'
    | '/service-requests'
    | '/tasks'
    | '/admins/$id/update'
    | '/business-lines/$id/update'
    | '/providers/$id/update'
    | '/requesters/$id/update'
    | '/service-requests/$id/smart-match'
    | '/service-requests/$id/update'
    | '/business-lines/$id'
    | '/providers/$id'
    | '/requesters/$id'
    | '/service-requests/$id'
    | '/business-lines/$id/services/create'
    | '/providers/$id/notes/create'
    | '/providers/$id/partnerships/create'
    | '/providers/$id/workers/create'
    | '/service-requests/$id/documents/add'
    | '/service-requests/$id/emails/send'
    | '/service-requests/$id/interventions/create'
    | '/service-requests/$id/notes/create'
    | '/service-requests/$id/tasks/create'
    | '/business-lines/$id/services/$serviceId/update'
    | '/providers/$id/companies/$companyId/update'
    | '/providers/$id/notes/$noteId/update'
    | '/providers/$id/partnerships/$partnershipId/update'
    | '/service-requests/$id/interventions/$interventionId/update'
    | '/service-requests/$id/notes/$noteId/update'
    | '/service-requests/$id/tasks/$taskId/update'
    | '/service-requests/$id/interventions/$interventionId/documents/add'
    | '/service-requests/$id/interventions/$interventionId/emails/send'
    | '/service-requests/$id/interventions/$interventionId/notes/create'
    | '/service-requests/$id/interventions/$interventionId/tasks/create'
    | '/service-requests/$id/interventions/$interventionId/notes/$noteId/update'
    | '/service-requests/$id/interventions/$interventionId/tasks/$taskId/update'
  id:
    | '__root__'
    | '/_auth-layout'
    | '/_layout'
    | '/redirecting'
    | '/unauthorized'
    | '/_auth-layout/'
    | '/_auth-layout/(auth)/forgot-password'
    | '/_layout/(private)/dashboard'
    | '/_layout/(private)/profile'
    | '/_layout/(private)/admins/create'
    | '/_layout/(private)/business-lines/create'
    | '/_layout/(private)/service-requests/create'
    | '/_layout/(private)/admins/'
    | '/_layout/(private)/business-lines/'
    | '/_layout/(private)/interventions/'
    | '/_layout/(private)/providers/'
    | '/_layout/(private)/service-requests/'
    | '/_layout/(private)/tasks/'
    | '/_layout/(private)/admins/$id/update'
    | '/_layout/(private)/business-lines/$id/update'
    | '/_layout/(private)/providers/$id/update'
    | '/_layout/(private)/requesters/$id/update'
    | '/_layout/(private)/service-requests/$id/smart-match'
    | '/_layout/(private)/service-requests/$id/update'
    | '/_layout/(private)/business-lines/$id/'
    | '/_layout/(private)/providers/$id/'
    | '/_layout/(private)/requesters/$id/'
    | '/_layout/(private)/service-requests/$id/'
    | '/_layout/(private)/business-lines/$id/services/create'
    | '/_layout/(private)/providers/$id/notes/create'
    | '/_layout/(private)/providers/$id/partnerships/create'
    | '/_layout/(private)/providers/$id/workers/create'
    | '/_layout/(private)/service-requests/$id/documents/add'
    | '/_layout/(private)/service-requests/$id/emails/send'
    | '/_layout/(private)/service-requests/$id/interventions/create'
    | '/_layout/(private)/service-requests/$id/notes/create'
    | '/_layout/(private)/service-requests/$id/tasks/create'
    | '/_layout/(private)/business-lines/$id/services/$serviceId/update'
    | '/_layout/(private)/providers/$id/companies/$companyId/update'
    | '/_layout/(private)/providers/$id/notes/$noteId/update'
    | '/_layout/(private)/providers/$id/partnerships/$partnershipId/update'
    | '/_layout/(private)/service-requests/$id/interventions/$interventionId/update'
    | '/_layout/(private)/service-requests/$id/notes/$noteId/update'
    | '/_layout/(private)/service-requests/$id/tasks/$taskId/update'
    | '/_layout/(private)/service-requests/$id/interventions/$interventionId/documents/add'
    | '/_layout/(private)/service-requests/$id/interventions/$interventionId/emails/send'
    | '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/create'
    | '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/create'
    | '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/$noteId/update'
    | '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/$taskId/update'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  LayoutRoute: typeof LayoutRouteWithChildren
  RedirectingRoute: typeof RedirectingRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redirecting': {
      id: '/redirecting'
      path: '/redirecting'
      fullPath: '/redirecting'
      preLoaderRoute: typeof RedirectingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-layout': {
      id: '/_auth-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-layout/': {
      id: '/_auth-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthLayoutIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_layout/(private)/profile': {
      id: '/_layout/(private)/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LayoutprivateProfileRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/dashboard': {
      id: '/_layout/(private)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LayoutprivateDashboardRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_auth-layout/(auth)/forgot-password': {
      id: '/_auth-layout/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthLayoutauthForgotPasswordRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_layout/(private)/tasks/': {
      id: '/_layout/(private)/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof LayoutprivateTasksIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/': {
      id: '/_layout/(private)/service-requests/'
      path: '/service-requests'
      fullPath: '/service-requests'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/': {
      id: '/_layout/(private)/providers/'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof LayoutprivateProvidersIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/interventions/': {
      id: '/_layout/(private)/interventions/'
      path: '/interventions'
      fullPath: '/interventions'
      preLoaderRoute: typeof LayoutprivateInterventionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/business-lines/': {
      id: '/_layout/(private)/business-lines/'
      path: '/business-lines'
      fullPath: '/business-lines'
      preLoaderRoute: typeof LayoutprivateBusinessLinesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/admins/': {
      id: '/_layout/(private)/admins/'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof LayoutprivateAdminsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/create': {
      id: '/_layout/(private)/service-requests/create'
      path: '/service-requests/create'
      fullPath: '/service-requests/create'
      preLoaderRoute: typeof LayoutprivateServiceRequestsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/business-lines/create': {
      id: '/_layout/(private)/business-lines/create'
      path: '/business-lines/create'
      fullPath: '/business-lines/create'
      preLoaderRoute: typeof LayoutprivateBusinessLinesCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/admins/create': {
      id: '/_layout/(private)/admins/create'
      path: '/admins/create'
      fullPath: '/admins/create'
      preLoaderRoute: typeof LayoutprivateAdminsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/': {
      id: '/_layout/(private)/service-requests/$id/'
      path: '/service-requests/$id'
      fullPath: '/service-requests/$id'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/requesters/$id/': {
      id: '/_layout/(private)/requesters/$id/'
      path: '/requesters/$id'
      fullPath: '/requesters/$id'
      preLoaderRoute: typeof LayoutprivateRequestersIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/': {
      id: '/_layout/(private)/providers/$id/'
      path: '/providers/$id'
      fullPath: '/providers/$id'
      preLoaderRoute: typeof LayoutprivateProvidersIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/business-lines/$id/': {
      id: '/_layout/(private)/business-lines/$id/'
      path: '/business-lines/$id'
      fullPath: '/business-lines/$id'
      preLoaderRoute: typeof LayoutprivateBusinessLinesIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/update': {
      id: '/_layout/(private)/service-requests/$id/update'
      path: '/service-requests/$id/update'
      fullPath: '/service-requests/$id/update'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/smart-match': {
      id: '/_layout/(private)/service-requests/$id/smart-match'
      path: '/service-requests/$id/smart-match'
      fullPath: '/service-requests/$id/smart-match'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdSmartMatchRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/requesters/$id/update': {
      id: '/_layout/(private)/requesters/$id/update'
      path: '/requesters/$id/update'
      fullPath: '/requesters/$id/update'
      preLoaderRoute: typeof LayoutprivateRequestersIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/update': {
      id: '/_layout/(private)/providers/$id/update'
      path: '/providers/$id/update'
      fullPath: '/providers/$id/update'
      preLoaderRoute: typeof LayoutprivateProvidersIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/business-lines/$id/update': {
      id: '/_layout/(private)/business-lines/$id/update'
      path: '/business-lines/$id/update'
      fullPath: '/business-lines/$id/update'
      preLoaderRoute: typeof LayoutprivateBusinessLinesIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/admins/$id/update': {
      id: '/_layout/(private)/admins/$id/update'
      path: '/admins/$id/update'
      fullPath: '/admins/$id/update'
      preLoaderRoute: typeof LayoutprivateAdminsIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/tasks/create': {
      id: '/_layout/(private)/service-requests/$id/tasks/create'
      path: '/service-requests/$id/tasks/create'
      fullPath: '/service-requests/$id/tasks/create'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdTasksCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/notes/create': {
      id: '/_layout/(private)/service-requests/$id/notes/create'
      path: '/service-requests/$id/notes/create'
      fullPath: '/service-requests/$id/notes/create'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdNotesCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/create': {
      id: '/_layout/(private)/service-requests/$id/interventions/create'
      path: '/service-requests/$id/interventions/create'
      fullPath: '/service-requests/$id/interventions/create'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/emails/send': {
      id: '/_layout/(private)/service-requests/$id/emails/send'
      path: '/service-requests/$id/emails/send'
      fullPath: '/service-requests/$id/emails/send'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdEmailsSendRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/documents/add': {
      id: '/_layout/(private)/service-requests/$id/documents/add'
      path: '/service-requests/$id/documents/add'
      fullPath: '/service-requests/$id/documents/add'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdDocumentsAddRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/workers/create': {
      id: '/_layout/(private)/providers/$id/workers/create'
      path: '/providers/$id/workers/create'
      fullPath: '/providers/$id/workers/create'
      preLoaderRoute: typeof LayoutprivateProvidersIdWorkersCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/partnerships/create': {
      id: '/_layout/(private)/providers/$id/partnerships/create'
      path: '/providers/$id/partnerships/create'
      fullPath: '/providers/$id/partnerships/create'
      preLoaderRoute: typeof LayoutprivateProvidersIdPartnershipsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/notes/create': {
      id: '/_layout/(private)/providers/$id/notes/create'
      path: '/providers/$id/notes/create'
      fullPath: '/providers/$id/notes/create'
      preLoaderRoute: typeof LayoutprivateProvidersIdNotesCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/business-lines/$id/services/create': {
      id: '/_layout/(private)/business-lines/$id/services/create'
      path: '/business-lines/$id/services/create'
      fullPath: '/business-lines/$id/services/create'
      preLoaderRoute: typeof LayoutprivateBusinessLinesIdServicesCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/tasks/$taskId/update': {
      id: '/_layout/(private)/service-requests/$id/tasks/$taskId/update'
      path: '/service-requests/$id/tasks/$taskId/update'
      fullPath: '/service-requests/$id/tasks/$taskId/update'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdTasksTaskIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/notes/$noteId/update': {
      id: '/_layout/(private)/service-requests/$id/notes/$noteId/update'
      path: '/service-requests/$id/notes/$noteId/update'
      fullPath: '/service-requests/$id/notes/$noteId/update'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdNotesNoteIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/$interventionId/update': {
      id: '/_layout/(private)/service-requests/$id/interventions/$interventionId/update'
      path: '/service-requests/$id/interventions/$interventionId/update'
      fullPath: '/service-requests/$id/interventions/$interventionId/update'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/partnerships/$partnershipId/update': {
      id: '/_layout/(private)/providers/$id/partnerships/$partnershipId/update'
      path: '/providers/$id/partnerships/$partnershipId/update'
      fullPath: '/providers/$id/partnerships/$partnershipId/update'
      preLoaderRoute: typeof LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/notes/$noteId/update': {
      id: '/_layout/(private)/providers/$id/notes/$noteId/update'
      path: '/providers/$id/notes/$noteId/update'
      fullPath: '/providers/$id/notes/$noteId/update'
      preLoaderRoute: typeof LayoutprivateProvidersIdNotesNoteIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/providers/$id/companies/$companyId/update': {
      id: '/_layout/(private)/providers/$id/companies/$companyId/update'
      path: '/providers/$id/companies/$companyId/update'
      fullPath: '/providers/$id/companies/$companyId/update'
      preLoaderRoute: typeof LayoutprivateProvidersIdCompaniesCompanyIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/business-lines/$id/services/$serviceId/update': {
      id: '/_layout/(private)/business-lines/$id/services/$serviceId/update'
      path: '/business-lines/$id/services/$serviceId/update'
      fullPath: '/business-lines/$id/services/$serviceId/update'
      preLoaderRoute: typeof LayoutprivateBusinessLinesIdServicesServiceIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/create': {
      id: '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/create'
      path: '/service-requests/$id/interventions/$interventionId/tasks/create'
      fullPath: '/service-requests/$id/interventions/$interventionId/tasks/create'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/create': {
      id: '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/create'
      path: '/service-requests/$id/interventions/$interventionId/notes/create'
      fullPath: '/service-requests/$id/interventions/$interventionId/notes/create'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/$interventionId/emails/send': {
      id: '/_layout/(private)/service-requests/$id/interventions/$interventionId/emails/send'
      path: '/service-requests/$id/interventions/$interventionId/emails/send'
      fullPath: '/service-requests/$id/interventions/$interventionId/emails/send'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/$interventionId/documents/add': {
      id: '/_layout/(private)/service-requests/$id/interventions/$interventionId/documents/add'
      path: '/service-requests/$id/interventions/$interventionId/documents/add'
      fullPath: '/service-requests/$id/interventions/$interventionId/documents/add'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/$taskId/update': {
      id: '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/$taskId/update'
      path: '/service-requests/$id/interventions/$interventionId/tasks/$taskId/update'
      fullPath: '/service-requests/$id/interventions/$interventionId/tasks/$taskId/update'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/$noteId/update': {
      id: '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/$noteId/update'
      path: '/service-requests/$id/interventions/$interventionId/notes/$noteId/update'
      fullPath: '/service-requests/$id/interventions/$interventionId/notes/$noteId/update'
      preLoaderRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface AuthLayoutRouteChildren {
  AuthLayoutIndexRoute: typeof AuthLayoutIndexRoute
  AuthLayoutauthForgotPasswordRoute: typeof AuthLayoutauthForgotPasswordRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutIndexRoute: AuthLayoutIndexRoute,
  AuthLayoutauthForgotPasswordRoute: AuthLayoutauthForgotPasswordRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface LayoutRouteChildren {
  LayoutprivateDashboardRoute: typeof LayoutprivateDashboardRoute
  LayoutprivateProfileRoute: typeof LayoutprivateProfileRoute
  LayoutprivateAdminsCreateRoute: typeof LayoutprivateAdminsCreateRoute
  LayoutprivateBusinessLinesCreateRoute: typeof LayoutprivateBusinessLinesCreateRoute
  LayoutprivateServiceRequestsCreateRoute: typeof LayoutprivateServiceRequestsCreateRoute
  LayoutprivateAdminsIndexRoute: typeof LayoutprivateAdminsIndexRoute
  LayoutprivateBusinessLinesIndexRoute: typeof LayoutprivateBusinessLinesIndexRoute
  LayoutprivateInterventionsIndexRoute: typeof LayoutprivateInterventionsIndexRoute
  LayoutprivateProvidersIndexRoute: typeof LayoutprivateProvidersIndexRoute
  LayoutprivateServiceRequestsIndexRoute: typeof LayoutprivateServiceRequestsIndexRoute
  LayoutprivateTasksIndexRoute: typeof LayoutprivateTasksIndexRoute
  LayoutprivateAdminsIdUpdateRoute: typeof LayoutprivateAdminsIdUpdateRoute
  LayoutprivateBusinessLinesIdUpdateRoute: typeof LayoutprivateBusinessLinesIdUpdateRoute
  LayoutprivateProvidersIdUpdateRoute: typeof LayoutprivateProvidersIdUpdateRoute
  LayoutprivateRequestersIdUpdateRoute: typeof LayoutprivateRequestersIdUpdateRoute
  LayoutprivateServiceRequestsIdSmartMatchRoute: typeof LayoutprivateServiceRequestsIdSmartMatchRoute
  LayoutprivateServiceRequestsIdUpdateRoute: typeof LayoutprivateServiceRequestsIdUpdateRoute
  LayoutprivateBusinessLinesIdIndexRoute: typeof LayoutprivateBusinessLinesIdIndexRoute
  LayoutprivateProvidersIdIndexRoute: typeof LayoutprivateProvidersIdIndexRoute
  LayoutprivateRequestersIdIndexRoute: typeof LayoutprivateRequestersIdIndexRoute
  LayoutprivateServiceRequestsIdIndexRoute: typeof LayoutprivateServiceRequestsIdIndexRoute
  LayoutprivateBusinessLinesIdServicesCreateRoute: typeof LayoutprivateBusinessLinesIdServicesCreateRoute
  LayoutprivateProvidersIdNotesCreateRoute: typeof LayoutprivateProvidersIdNotesCreateRoute
  LayoutprivateProvidersIdPartnershipsCreateRoute: typeof LayoutprivateProvidersIdPartnershipsCreateRoute
  LayoutprivateProvidersIdWorkersCreateRoute: typeof LayoutprivateProvidersIdWorkersCreateRoute
  LayoutprivateServiceRequestsIdDocumentsAddRoute: typeof LayoutprivateServiceRequestsIdDocumentsAddRoute
  LayoutprivateServiceRequestsIdEmailsSendRoute: typeof LayoutprivateServiceRequestsIdEmailsSendRoute
  LayoutprivateServiceRequestsIdInterventionsCreateRoute: typeof LayoutprivateServiceRequestsIdInterventionsCreateRoute
  LayoutprivateServiceRequestsIdNotesCreateRoute: typeof LayoutprivateServiceRequestsIdNotesCreateRoute
  LayoutprivateServiceRequestsIdTasksCreateRoute: typeof LayoutprivateServiceRequestsIdTasksCreateRoute
  LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute: typeof LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute
  LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute: typeof LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute
  LayoutprivateProvidersIdNotesNoteIdUpdateRoute: typeof LayoutprivateProvidersIdNotesNoteIdUpdateRoute
  LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute: typeof LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute
  LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute
  LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute: typeof LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute
  LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute: typeof LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute
  LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute
  LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute
  LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute
  LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute
  LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute
  LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute: typeof LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutprivateDashboardRoute: LayoutprivateDashboardRoute,
  LayoutprivateProfileRoute: LayoutprivateProfileRoute,
  LayoutprivateAdminsCreateRoute: LayoutprivateAdminsCreateRoute,
  LayoutprivateBusinessLinesCreateRoute: LayoutprivateBusinessLinesCreateRoute,
  LayoutprivateServiceRequestsCreateRoute:
    LayoutprivateServiceRequestsCreateRoute,
  LayoutprivateAdminsIndexRoute: LayoutprivateAdminsIndexRoute,
  LayoutprivateBusinessLinesIndexRoute: LayoutprivateBusinessLinesIndexRoute,
  LayoutprivateInterventionsIndexRoute: LayoutprivateInterventionsIndexRoute,
  LayoutprivateProvidersIndexRoute: LayoutprivateProvidersIndexRoute,
  LayoutprivateServiceRequestsIndexRoute:
    LayoutprivateServiceRequestsIndexRoute,
  LayoutprivateTasksIndexRoute: LayoutprivateTasksIndexRoute,
  LayoutprivateAdminsIdUpdateRoute: LayoutprivateAdminsIdUpdateRoute,
  LayoutprivateBusinessLinesIdUpdateRoute:
    LayoutprivateBusinessLinesIdUpdateRoute,
  LayoutprivateProvidersIdUpdateRoute: LayoutprivateProvidersIdUpdateRoute,
  LayoutprivateRequestersIdUpdateRoute: LayoutprivateRequestersIdUpdateRoute,
  LayoutprivateServiceRequestsIdSmartMatchRoute:
    LayoutprivateServiceRequestsIdSmartMatchRoute,
  LayoutprivateServiceRequestsIdUpdateRoute:
    LayoutprivateServiceRequestsIdUpdateRoute,
  LayoutprivateBusinessLinesIdIndexRoute:
    LayoutprivateBusinessLinesIdIndexRoute,
  LayoutprivateProvidersIdIndexRoute: LayoutprivateProvidersIdIndexRoute,
  LayoutprivateRequestersIdIndexRoute: LayoutprivateRequestersIdIndexRoute,
  LayoutprivateServiceRequestsIdIndexRoute:
    LayoutprivateServiceRequestsIdIndexRoute,
  LayoutprivateBusinessLinesIdServicesCreateRoute:
    LayoutprivateBusinessLinesIdServicesCreateRoute,
  LayoutprivateProvidersIdNotesCreateRoute:
    LayoutprivateProvidersIdNotesCreateRoute,
  LayoutprivateProvidersIdPartnershipsCreateRoute:
    LayoutprivateProvidersIdPartnershipsCreateRoute,
  LayoutprivateProvidersIdWorkersCreateRoute:
    LayoutprivateProvidersIdWorkersCreateRoute,
  LayoutprivateServiceRequestsIdDocumentsAddRoute:
    LayoutprivateServiceRequestsIdDocumentsAddRoute,
  LayoutprivateServiceRequestsIdEmailsSendRoute:
    LayoutprivateServiceRequestsIdEmailsSendRoute,
  LayoutprivateServiceRequestsIdInterventionsCreateRoute:
    LayoutprivateServiceRequestsIdInterventionsCreateRoute,
  LayoutprivateServiceRequestsIdNotesCreateRoute:
    LayoutprivateServiceRequestsIdNotesCreateRoute,
  LayoutprivateServiceRequestsIdTasksCreateRoute:
    LayoutprivateServiceRequestsIdTasksCreateRoute,
  LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute:
    LayoutprivateBusinessLinesIdServicesServiceIdUpdateRoute,
  LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute:
    LayoutprivateProvidersIdCompaniesCompanyIdUpdateRoute,
  LayoutprivateProvidersIdNotesNoteIdUpdateRoute:
    LayoutprivateProvidersIdNotesNoteIdUpdateRoute,
  LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute:
    LayoutprivateProvidersIdPartnershipsPartnershipIdUpdateRoute,
  LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute:
    LayoutprivateServiceRequestsIdInterventionsInterventionIdUpdateRoute,
  LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute:
    LayoutprivateServiceRequestsIdNotesNoteIdUpdateRoute,
  LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute:
    LayoutprivateServiceRequestsIdTasksTaskIdUpdateRoute,
  LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute:
    LayoutprivateServiceRequestsIdInterventionsInterventionIdDocumentsAddRoute,
  LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute:
    LayoutprivateServiceRequestsIdInterventionsInterventionIdEmailsSendRoute,
  LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute:
    LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesCreateRoute,
  LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute:
    LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksCreateRoute,
  LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute:
    LayoutprivateServiceRequestsIdInterventionsInterventionIdNotesNoteIdUpdateRoute,
  LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute:
    LayoutprivateServiceRequestsIdInterventionsInterventionIdTasksTaskIdUpdateRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  LayoutRoute: LayoutRouteWithChildren,
  RedirectingRoute: RedirectingRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
